import { render, staticRenderFns } from "./PostContainer.vue?vue&type=template&id=0b551c4a&scoped=true&"
import script from "./PostContainer.vue?vue&type=script&lang=js&"
export * from "./PostContainer.vue?vue&type=script&lang=js&"
import style0 from "./PostContainer.vue?vue&type=style&index=0&id=0b551c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b551c4a",
  null
  
)

export default component.exports